import Vue from 'vue'
import GenericTooltip from '@/components/generic-tooltip'
import { getTooltipPosition, getTooltipOrientations, updateTooltipElementPosition, isTooltipElementMounted } from './generic-tooltip.utils'

export default {
  bind(el, binding, vnode) {
    const TooltipComponent = Vue.extend(GenericTooltip)
    let tooltipInstance = null
    let checkExistInterval = null

    const showTooltip = () => {
      const isTheContainerBox = el.parentElement.getBoundingClientRect().top === el.getBoundingClientRect().top
      if (isTheContainerBox) return

      if (tooltipInstance) { tooltipInstance = null }
      tooltipInstance = new TooltipComponent({
        propsData: binding.value,
        parent: vnode.context
      }).$mount()
      document.body.appendChild(tooltipInstance.$el)

      Vue.nextTick(() => {
        if (!isTooltipElementMounted(tooltipInstance.$el)) return;
        const { orientationX, orientationY } = getTooltipOrientations(el, tooltipInstance.$el)
        tooltipInstance.$set(tooltipInstance.$props, 'orientation', { x: orientationX, y: orientationY })
        const { left, top } = getTooltipPosition(el, tooltipInstance.$el, { orientationX, orientationY })
        updateTooltipElementPosition(tooltipInstance.$el, { left, top })
      })

      checkExistInterval = setInterval(() => {
        if (!el) {
          // Deletes the tooltip if the element pointed to by the tooltip is no longer present. 
          hideTooltip()
          clearInterval(checkExistInterval)
        } else if (el) {
          // If the element is still present in the DOM but is no longer visible, then delete the tooltip
          const rect = el.getBoundingClientRect();
          const isVisble = rect.width > 0 && rect.height > 0;
  
          if (!isVisble) {
            hideTooltip()
            clearInterval(checkExistInterval)
          }
        }
      }, 100)
    }

    const hideTooltip = () => {
      if (tooltipInstance) {
        checkExistInterval && clearInterval(checkExistInterval)
        tooltipInstance.$el.style.display = 'none'
      }
    }

    el.addEventListener('mouseenter', showTooltip)
    el.addEventListener('mouseleave', hideTooltip)
    el.addEventListener('click', hideTooltip)

    el._tooltipInstance = tooltipInstance
    el._showTooltip = showTooltip
    el._hideTooltip = hideTooltip
  },
  unbind(el) {
    el.removeEventListener('mouseenter', el._showTooltip)
    el.removeEventListener('mouseleave', el._hideTooltip)
    if (el._tooltipInstance) {
      el._tooltipInstance.$destroy()
      document.body.removeChild(el._tooltipInstance.$el)
    }
  }
}